import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/metaPixel';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  children: React.ReactNode;
  className?: string;
  size?: 'md' | 'lg';
  /** Use "#comprar" to scroll to the pricing block instead of going to checkout. */
  href?: string;
};
export function CtaButton({
  children,
  className = '',
  size = 'lg',
  href = CHECKOUT_URL
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg' : 'px-6 py-3.5 text-sm';
  const isCheckout = href === CHECKOUT_URL;
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'MegaPack Reto 30 Días Fit',
      value: 19990,
      currency: 'ARS'
    });
  };
  return <a href={href} onClick={handleClick} {...isCheckout ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex w-full items-center justify-center gap-3 rounded-full bg-gold-500 font-display uppercase tracking-wide text-ink-950 shadow-[0_10px_30px_-8px_rgba(232,182,90,0.6)] transition-transform duration-200 hover:scale-[1.02] hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-400 active:scale-[0.99] ${sizing} ${className}`} data-id="element-61" data-mp="19as5kzd3rf9z">
      <span data-id="element-62" data-mp="3jy8lfze12eh3">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-63" data-mp="3ow0amlnafmhl" />
    </a>;
}